import { SnackbarProvider } from 'notistack';

export default function CustomSnackbarProvider({ children }) {
  return <SnackbarProvider maxSnack={3}>{children}</SnackbarProvider>;
}
